/**
 * 常時効果システム: 効果定義集約
 *
 * このファイルは全属性/タイプの効果定義を集約してエクスポートします。
 * 新しい属性ファイルを追加した場合は、ここでインポートしてマージしてください。
 *
 * @see src/ルール/continuous-effect-system-design.md
 */

// 各属性/タイプの効果定義をインポート
import { fieldCardEffects } from './fieldCards';
import { monsterCardEffects } from './monsterCards';

// フェイズカード（段階別効果）
import {
  phaseCardEffectsByStage,
  getPhaseCardEffectsForStage,
  hasPhaseCardContinuousEffects,
  getAllPhaseCardEffects,
  getPhaseCardCount,
} from './phaseCards';

/** 効果定義アイテムの型 */
export interface EffectDefinitionItem {
  type: string;
  description?: string;
  value?: number;
  target?: string;
  condition?: Record<string, unknown>;
  [key: string]: unknown;
}

/** 効果定義の型（配列） */
export type EffectDefinition = EffectDefinitionItem[];

/** カードID => 効果定義のマップ */
export type EffectDefinitionMap = Record<string, EffectDefinition>;

/**
 * 全効果定義を集約したオブジェクト
 * カードID => 効果定義配列
 * Note: フェイズカードは段階別なので別管理
 */
export const allEffectDefinitions: EffectDefinitionMap = {
  // フィールドカード（23枚）
  ...fieldCardEffects,

  // モンスターカード（22枚）
  ...monsterCardEffects,
};

// フェイズカード関連をエクスポート
export {
  phaseCardEffectsByStage,
  getPhaseCardEffectsForStage,
  hasPhaseCardContinuousEffects,
  getAllPhaseCardEffects,
  getPhaseCardCount,
};

/** 特定カードの効果定義を取得 */
export const getEffectDefinition = (cardId: string): EffectDefinition | null => {
  return allEffectDefinitions[cardId] || null;
};

/** 効果定義が存在するかチェック */
export const hasEffectDefinition = (cardId: string): boolean => {
  return cardId in allEffectDefinitions;
};

/** 登録されている効果定義の数を取得 */
export const getEffectDefinitionCount = (): number => {
  return Object.keys(allEffectDefinitions).length;
};

/** 全カードIDを取得 */
export const getAllDefinedCardIds = (): string[] => {
  return Object.keys(allEffectDefinitions);
};
